import { StringifiableRecord } from "query-string";
import { z } from "zod/v3";

export type BaseEntity = {
  id: number;
};

export const baseEntitySchema = z.object({
  id: z.number().optional() // Not present when creating a new entity
});

export type PayloadAndQueryParams<Payload> = {
  payload: Partial<Payload>;
  queryParams?: StringifiableRecord;
};
